import type { QuoteLineMO, QuoteLinePartMO } from "~/features/orders/common/components/v2/models";
import type { GroupedQuoteLines } from "~/features/orders/common/components/v2/QuoteTable/types";
import { groupByFn, splitBy } from "~/common/utils/reducers";
import { DateFormatType } from "~/common/utils/DateFormatter";
import { formatShippingOrDeliveryDate } from "~/common/utils/dateUtils";

export function groupByMainQuoteLine(quoteLines: QuoteLineMO[]): GroupedQuoteLines[] {
  return Object.values(groupByFn(quoteLines, (quoteLine) => quoteLine.alternativeTo ?? quoteLine.lineNo)).map(
    (group) => {
      const split = splitBy(group, (quoteLine) => !!quoteLine.alternativeTo);
      const mainQuoteLine = split[1][0];
      const alternativeQuoteLines = split[0];
      return {
        mainQuoteLine,
        alternativeQuoteLines,
      };
    },
  );
}

export function splitAlternatives({ mainQuoteLine, alternativeQuoteLines }: GroupedQuoteLines) {
  function getKey(quoteLine: QuoteLineMO) {
    return [quoteLine.product.sapMaterialNumber, quoteLine.packCode].join("-");
  }

  const mainProductKey = getKey(mainQuoteLine);
  const quoteLinesByKey = groupByFn(alternativeQuoteLines, getKey);

  const sameProductAlternatives = quoteLinesByKey[mainProductKey] ?? [];
  delete quoteLinesByKey[mainProductKey];

  const differentProductAlternatives = Object.values(quoteLinesByKey).map((lines) => ({
    product: lines[0].product,
    quoteLines: lines,
  }));
  return { mainQuoteLine, sameProductAlternatives, differentProductAlternatives };
}

export function getEDD(part: QuoteLinePartMO) {
  return part.logisticalComment
    ? part.logisticalComment
    : formatShippingOrDeliveryDate(part.estimatedDeliveryDate, DateFormatType.DATE);
}
